import { flushSync } from 'react-dom';
import React, { useState, useEffect, useContext } from 'react';
import SectionsSelect from '../../SectionsSelect'
import { ShopContext } from '../../contexts/Shop'
import { CustomerContext } from '../../contexts/Customer'
import { EnrollmentsContext } from '../../contexts/yolk/Enrollments'
import { SectionsContext } from '../../contexts/yolk/Sections'
import {FormProvider} from '@thinkwell/react.common'
import {EditModal} from '@thinkwell/react.polaris'
import {HostContext} from '../../contexts/Host'

export default function EditRegisterRelated(props) {
  const host = useContext(HostContext)
  const shop_name = useContext(ShopContext)
  const [customer] = useContext(CustomerContext)
  const [enrollments, fetchEnrollments, fetchEnrollmentsState, upsertEnrollment] = useContext(EnrollmentsContext);
  const [sections, fetchSections] = useContext(SectionsContext);
  const [enrollmentId, setEnrollmentId] = useState();

  const onSectionChange = (value, form) => {
    try {
      value = JSON.parse(value)
    } catch (error) {}

    if (Array.isArray(value)) {
      console.log(`set enrollment/section : ${value[0]} : ${value[1]}`)
      flushSync(() => {
        setEnrollmentId(value[0])
      })
      flushSync(() => {
        form.onData('section_id')(value[1])
      })
    } else {
      console.log(`set section : ${value}`)
      flushSync(() => {
        form.onData('section_id')(value)
      })
    }
  }

  const onActive = async(active, form) => {
    if(active) {
      const url = `${host}/accounts/enrollments/${props.id}/sections/related.json?shop_name=${shop_name}`
      const sections = await fetchSections(url);
      const sectionId = form.field('section_id')
      const section = sectionId && (sections || []).find((section) => sectionId == section.id && enrollmentId == section.enrollment_id)
      if ((sections || []).length && !section) {
        console.log(`select first section ${sections[0].enrollment_id}/${sections[0].id} ${sectionId ? `(from ${sectionId})` : ''}`)
        flushSync(() => {
          setEnrollmentId(sections[0].enrollment_id)
        })
        flushSync(() => {
          form.onData('section_id')(sections[0].id)
        })
      }
    }
  }

  // props.id may contain multiple enrollment_id, therefore allowing for enrollment_id selection
  const url = (form) => {
    const urlPath = `enrollments/${enrollmentId || props.id}/sections/${form.field('section_id')}/register_related.json`
    return `${host}/accounts/${urlPath}?shop_name=${shop_name}&cid=${customer.id}`
  }

  const data = {
    section_id: props.sectionId
  }

  return (<FormProvider data={data}><EditModal
    onActive={onActive}
    onSave={upsertEnrollment}
    onSaving={props.onSaving}
    url={url}
    linkText='Register for another class'
    title="Register for another class"
    saveText="Register">
    <SectionsSelect
      required
      idFormat={(item) => item.enrollment_id ? JSON.stringify([item.enrollment_id, item.id]) : item.id}
      onChange={onSectionChange}
      notFoundMessage="There are no classes available for registration." />
  </EditModal></FormProvider>);
}
